import React from 'react';

import { fetchCategoryUiConfig } from 'app/actions/browse/browseCategoryActions';
import { performCatalogSearch } from 'app/actions/SearchActions';
import BrowseCategoryPage from 'app/components/browse/category';
import { BROWSE_CATEGORY_PAGE_FACET_FIELD_IDS, FILTERABLE_DISPLAY_BIB_GRID_LIMIT } from 'app/constants/BrowseConstants';
import { mapQueryStateToCatalogSearchParams } from 'app/helpers/browse';
import { deserializeQuerystring } from 'app/helpers/browse/browseQueryHelpers';
import connectRoute from 'app/routes/connectRoute';
import { selectCurrentSiteScopes } from 'app/selectors/ScopeSelector';

const BrowseCategoryPageRoute = () => <BrowseCategoryPage />;

const createPerformCatalogSearchForCategoryAction = search => {
  return state => {
    const searchParams = new URLSearchParams(search);
    const isLeaf = state.getIn(['browse', 'category', 'config', 'isLeaf']);
    const searchScopes = selectCurrentSiteScopes(state)?.toJS() ?? [];
    const searchQueryParams = state.getIn(['browse', 'category', 'config', 'searchQueryParams'])?.toJS();

    if (!isLeaf) {
      return { type: 'NOOP' };
    }

    const baseApiParams = {
      ...searchQueryParams,
      limit: FILTERABLE_DISPLAY_BIB_GRID_LIMIT,
      view: 'grouped'
    };

    const includedFieldIds = BROWSE_CATEGORY_PAGE_FACET_FIELD_IDS;
    const catalogSearchFilters = mapQueryStateToCatalogSearchParams(
      deserializeQuerystring(searchParams, {
        includedFieldIds,
        searchScopes
      }),
      { includedFieldIds }
    );

    return performCatalogSearch(
      { ...baseApiParams, ...catalogSearchFilters },
      { isPersistShowMoreFiltersFieldId: true }
    );
  };
};

const getRouteData = ({ dispatch, location, params, state }) => {
  const [categoryPath] = params ?? [];

  const serializedCategoryPath = '/'.concat(categoryPath || '').replace(/\/+$/, '');
  const loadedCategoryPath = state.getIn(['browse', 'category', 'config', 'categoryPath']);
  if (loadedCategoryPath === serializedCategoryPath) {
    return [dispatch(createPerformCatalogSearchForCategoryAction(location.search)(state))];
  }

  return [
    dispatch(
      fetchCategoryUiConfig({
        postSuccess: createPerformCatalogSearchForCategoryAction(location.search),
        categoryPath: serializedCategoryPath
      })
    )
  ];
};

export default connectRoute(BrowseCategoryPageRoute, { getRouteData });
